<template>
  <v-row>
    <v-col cols="6">
      <PER_ActiveEmployees @selection-changed="handleSelectionChanged" />
    </v-col>
    <v-col cols="6">
      <ValoriParametriiSalarizare
        :empId="selectedEmpId"
        :mode="selectedMode"
      />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import PER_ActiveEmployees from "./PER_ActiveEmployees.vue";
import ValoriParametriiSalarizare from "./ValoriParametriiSalarizare.vue";

export default {
  components: {
    PER_ActiveEmployees,
    ValoriParametriiSalarizare,
  },
  data() {
    return {
      selectedEmpId: null as string | null,
      selectedMode: 'Angajati' as 'Angajati' | 'Companie',
    };
  },
  methods: {
    handleSelectionChanged(payload: any) {
      this.selectedEmpId = payload?.empId ?? null;
      if (payload?.mode) {
        this.selectedMode = payload.mode;
      }
    },
  },
};
</script>
